<!-- Sem `windowMode`: ele existe para simular uma janela dentro da página, e o preço é uma
     faixa vazia acima do cabeçalho mais um teto de largura. Aqui a aplicação é a página. -->
<nb-layout class="layout-externo">
  <nb-layout-header fixed>
    <app-header-externo></app-header-externo>
  </nb-layout-header>

  <nb-sidebar
    class="sidebar-menu domus-sidebar"
    tag="menu-sidebar"
    [fixed]="sobreposto"
    [state]="estadoInicial"
    (stateChange)="aoMudarEstado($event)"
  >
    <nb-menu [items]="menuItems"></nb-menu>
  </nb-sidebar>

  <nb-layout-column class="layout-externo-content">
    <router-outlet></router-outlet>
  </nb-layout-column>

  <!-- `LAY-07` — faixa de respiro no pé da área logada: no celular, é o que tira o último
       botão ou card de baixo da barra do navegador. A assinatura mora aqui. -->
  <nb-layout-footer class="rodape-geral">
    <span class="rodape-assinatura">DOMUS DATA</span>
    <span class="rodape-produto">Catequese</span>
  </nb-layout-footer>
</nb-layout>
